import { Markdown } from "../components/Markdown"
import { UmbrellaTemplate } from "../templates/UmbrellaTemplate"
import "./UsPage.scss"

export function UsPage() {
  return (
    <UmbrellaTemplate title="Us - Blake & Christie">
      <Markdown path="us.md" />
    </UmbrellaTemplate>
  )
}
